export default __webpack_public_path__ + "static/media/fancychest.a11f505c.png";